import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { handleRejectedResponse } from './utils';
import { fetch as axios } from '../../axios_config';
import { notification } from 'antd';


export const AddLocation = createAsyncThunk(
  '/Add-new-location',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/location-management/`,
        body
      );
      return response;
    } catch (err) {
      return handleRejectedResponse(err, 'Add Location', rejectWithValue);
    }
  }
);
export const GetLocations = createAsyncThunk(
  '/get-locations',
  async (data, { rejectWithValue }) => {
    const { pagination: { pageNumber, pageLimit } = {}, searchValue, sortBy: {key,type} } = data || {};
    const params = {
      skip: Number(pageNumber),
      limit: Number(pageLimit),
      search: searchValue,
      key:key,
      type: type,
    }
    try {
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/location-management/`,
        { params }
      );
      return response;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Locations', rejectWithValue);
    }
  }
);

export const UpdateLocation = createAsyncThunk(
  '/update-location-name',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${process.env.OPULENT_NODE_API_URL}/location-management/`,
        body
      );
      return response;
    } catch (err) {
      return handleRejectedResponse(err, 'Update Location Name', rejectWithValue);
    }
  }
);

export const AddBulkLocations = createAsyncThunk(
  '/add-bulk-locations',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/location-management/bulk-locations`,
        body
      );
      return response;
    } catch (err) {
      return handleRejectedResponse(err, 'Add Bulk Locations', rejectWithValue);
    }
  }
);

export const DeleteLocation = createAsyncThunk(
  '/delete-location',
  async (body, { rejectWithValue }) => {
    try {
      const { locationId } = body;
      const response = await axios.delete(`${process.env.OPULENT_NODE_API_URL}/location-management/${locationId}`);
      return response;
    } catch (err) {
      return handleRejectedResponse(err, 'Delete Location', rejectWithValue);
    }
  }
);

export const GetLocationsList = createAsyncThunk(
  '/locations-list',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/location-management/locations-list`);

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Locations List', rejectWithValue);
    }
  }
);

export const GetLocationProducts = createAsyncThunk(
  '/products/:locationId',
  async (data, { rejectWithValue }) => {
    try {
      const { id, params } = data;
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/location-management/products/${id}`,
        { params }
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Location Products', rejectWithValue);
    }
  }
);

export const GetLocationHistories = createAsyncThunk(
  '/histories/:productId',
  async (data, { rejectWithValue }) => {
    try {
      const { id, params } = data;
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/location-management/histories/${id}`,
        { params }
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Location History', rejectWithValue);
    }
  }
);

export const AdjustInventory = createAsyncThunk(
  '/adjust-inventory',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/location-management/adjust-inventory`,
        body
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Adjust Inventory', rejectWithValue);
    }
  }
);

export const MoveToLocation = createAsyncThunk(
  '/adjust-inventory',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/location-management/relocate-product`,
        body
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Move To Location', rejectWithValue);
    }
  }
);

export const BulkAdjustInventory = createAsyncThunk(
  '/bulk-adjust-inventory',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/location-management/bulk-inventory-adjustment`,
        body
      );

      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Move To Location', rejectWithValue);
    }
  }
);

const locationManagement = createSlice({
  name: "locationManagement",
  initialState: {
    createLocationLoading: false,
    getLocationsLoading: false,
    updateLocationLoading: false,
    bulkLocationsLoading: false,
    deleteLocationLoading: false,
    locations: [],
    locationsCount: 0,
    fileUrl : null,
    addInventoryFileUrl: null,

    locationDetails: {},
    fetchingLocationProducts: false,
    totalLocationProductsCount: 0,
    locationProducts: [],

    fetchingLocationHistories: false,
    totalLocationHistoriesCount: 0,
    locationHistories: [],

    fetchingLocationsList: false,
    locationsList: [],

    adjustingInventory: false,
    movingLocation: false,
  },
  reducers: {
    setField(state, { payload: { field, index, key, value } }) {
      state[field][index][key] = value;
    },
  },
  extraReducers: {
    [AddLocation.pending]: (state) => ({
      ...state,
      createLocationLoading: true
    }),
    [AddLocation.fulfilled]: (state) => {
      notification.success({
        message: 'Location Added Successfully',
        top: 65,
      })
      return {
        ...state,
        createLocationLoading: false
      }
    },
    [AddLocation.rejected]: (state) => {
      return {
        ...state,
        createLocationLoading: false
      }
    },
    [GetLocations.pending]: (state) => ({
      ...state,
      getLocationsLoading: true,
      locations: []
    }),
    [GetLocations.fulfilled]: (state, action) => {
      const { locations, locationsCount = 0, fileUrl = null, addInventoryFileUrl = null } = action?.payload?.data || {};
      return {
        ...state,
        locations,
        locationsCount,
        fileUrl,
        addInventoryFileUrl,
        getLocationsLoading: false
      }
    },
    [GetLocations.rejected]: (state) => {
      return {
        ...state,
        getLocationsLoading: false
      }
    },
    [UpdateLocation.pending]: (state) => ({
      ...state,
      updateLocationLoading: true
    }),
    [UpdateLocation.fulfilled]: (state) => {
      notification.success({
        message: 'Location Name updated successfully',
        top: 65,
      })
      return {
        ...state,
        updateLocationLoading: false
      }
    },
    [UpdateLocation.rejected]: (state) => {
      return {
        ...state,
        updateLocationLoading: false
      }
    },
    [AddBulkLocations.pending]: (state) => ({
      ...state,
      bulkLocationsLoading: true
    }),
    [AddBulkLocations.fulfilled]: (state) => ({
      ...state,
      bulkLocationsLoading: false
    }),
    [AddBulkLocations.rejected]: (state) => {
      return {
        ...state,
        bulkLocationsLoading: false
      }
    },
    [DeleteLocation.pending]: (state) => ({
      ...state,
      deleteLocationLoading: true
    }),
    [DeleteLocation.fulfilled]: (state) => {
      notification.success({
        message: 'Location Deleted Successfully',
        top: 65,
      })
      return {
        ...state,
        deleteLocationLoading: false,
      }
    },
    [DeleteLocation.rejected]: (state) => ({
      ...state,
      deleteLocationLoading: false
    }),

    [GetLocationsList.pending]: (state) => {
      state.fetchingLocationsList = true;
      state.locationsList = [];
    },
    [GetLocationsList.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};

      state.fetchingLocationsList = false;
      state.locationsList = data?.map?.(({ id, name }) => ({ value: id, label: name }));
    },
    [GetLocationsList.rejected]: (state) => {
      state.fetchingLocationsList = false;
    },

    [GetLocationHistories.pending]: (state) => {
      state.fetchingLocationHistories = true;
      state.locationHistories = [];
      state.totalLocationHistoriesCount = 0;
    },
    [GetLocationHistories.fulfilled]: (state, action) => {
      const { data, count } = action?.payload || {};

      state.fetchingLocationHistories = false;
      state.locationHistories = data;
      state.totalLocationHistoriesCount = count;
    },
    [GetLocationHistories.rejected]: (state) => {
      state.fetchingLocationHistories = false;
    },

    [GetLocationProducts.pending]: (state) => {
      state.fetchingLocationProducts = true;
      state.locationProducts = [];
      state.totalLocationProductsCount = 0;
    },
    [GetLocationProducts.fulfilled]: (state, action) => {
      const { data, count, location } = action?.payload || {};

      state.locationDetails = location;
      state.fetchingLocationProducts = false;
      state.locationProducts = data;
      state.totalLocationProductsCount = count;
    },
    [GetLocationProducts.rejected]: (state) => {
      state.fetchingLocationProducts = false;
    },

    [MoveToLocation.pending]: (state) => {
      state.movingLocation = true;
    },
    [MoveToLocation.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.movingLocation = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [MoveToLocation.rejected]: (state) => {
      state.movingLocation = false;
    },

    [AdjustInventory.pending]: (state) => {
      state.adjustingInventory = true;
    },
    [AdjustInventory.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.adjustingInventory = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [AdjustInventory.rejected]: (state) => {
      state.adjustingInventory = false;
    },
  }
});

const { reducer, actions } = locationManagement;

export const {
  setField,
} = actions;

export default reducer;